export default __webpack_public_path__ + "static/media/product-image-hover-8.8c2d59ba.jpg";